import { lazy, Suspense, useEffect, useState, useSyncExternalStore } from 'react';
import { useAuth } from '@/auth/AuthContext';
import { clearStore, readActive, setActive, subscribeActive } from './gate';

// Lazy: the lesson book, its practice records and the runner load only when
// a lesson runs. The gate above is tiny and ships with the shell.
const LessonRunner = lazy(() => import('./LessonRunner').then((m) => ({ default: m.LessonRunner })));

/**
 * Mounted once in the shell, beside the onboarding host. Shows the running
 * lesson (started from Help ▸ Tutorials) and its "lesson done" card. Never
 * starts anything by itself: no lesson runs unless the person pressed Start.
 */
export function TutorialsHost() {
  const { user, isLoading } = useAuth();
  const active = useSyncExternalStore(subscribeActive, readActive, () => null);
  const [mounted, setMounted] = useState(() => !!active);

  useEffect(() => {
    if (active) setMounted(true);
  }, [active]);

  // Signed out (or an agent session): no lesson survives it.
  useEffect(() => {
    if (isLoading) return;
    if (active && (!user || user.role === 'agent')) {
      setActive(null);
      clearStore();
    }
  }, [active, user, isLoading]);

  if (!mounted || !user || user.role === 'agent') return null;
  return (
    <Suspense fallback={null}>
      <LessonRunner />
    </Suspense>
  );
}
